import axiosMapInstance from "../interceptor/webMapInstance";

const baseUrl = `${process.env.REACT_APP_BASE_URL_WEB_MAP}/location`;
const countryBaseUrl = `${process.env.REACT_APP_BASE_URL_WEB_MAP}/country`;

  export const getDataForInitialAdminLevels = async (countryCode,adminLevel,quarter) => {
    const response = await axiosMapInstance.get(
        `${baseUrl}/${countryCode}/${adminLevel}?quarter=${quarter}`
      );
    return response.data;
  };

  export const getAdminLevelsBySelectedValue = async (location) => {
    const response = await axiosMapInstance.get(
        `${baseUrl}/${location.code}/${location.level}/${location.value}?quarter=${location.quarter}`,
        {
          params:{
            ...(location.adminLevel1 && {adminLevel1 : location.adminLevel1}),
            ...(location.adminLevel2 && {adminLevel2 : location.adminLevel2}) ,
          }
        }
      );
    return response.data;
  };

  export const getCountries = async () => {
    const response = await axiosMapInstance.get(
      countryBaseUrl
    );
    return response.data;
  };

  export const getPolygonByAdminLevel = async (data, perPage, page = 1, hideLoader = false, cancelToken) => {
    const response = await axiosMapInstance.get(
      `${baseUrl}/polygon/${data.countryCode}/${data.borderLvl || "ADM3"}?limit=${perPage}&page=${page}`,
      {
        params: {
          adminLevel1: data.adminLevel1,
          adminLevel2: data.adminLevel2,
          adminLevel3: data.adminLevel3,
        },
        hideLoader: hideLoader,
        cancelToken: cancelToken?.token
      }
    );
    return response.data;
  };

  export const fetchYearAndQuarterByCountry = async (countryCode) => {
    const response = await axiosMapInstance.get(
        `${baseUrl}/${countryCode}`
      );
    return response.data;
  };